/**
 * Basic TomSelect for a one selection dropdown with visible placeholder
 *
 */
import TomSelectController from "./tom_select_controller";

export default class extends TomSelectController {
  static values = {
    allowEmptyOption: { type: Boolean, default: true },
    showRemoveButton: { type: Boolean, default: false },
  };

  configuration(overrides = {}) {
    const plugins =
      this.element.attributes["multiple"] || this.showRemoveButtonValue
        ? ["remove_button", "dropdown_input"]
        : ["dropdown_input"];

    return super.configuration({
      plugins: plugins,
      allowEmptyOption: this.allowEmptyOptionValue,
      closeAfterSelect: !this.element.attributes["multiple"],
      ...overrides,
    });
  }

  connect() {
    if (!super.connect()) return;

    this.tomselect.on("item_add", function (value, item) {
      this.setTextboxValue("");
    });

    if (this.tomselect.settings.closeAfterSelect) {
      this.tomselect.on("item_add", function (value, item) {
        this.blur();
      });
    }
  }
}
